import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a8cb9de&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5a8cb9de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8cb9de",
  null
  
)

export default component.exports